import React from 'react';
import PublicHeader from './PublicHeader';
import Breadcrumb from './Breadcrumb';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

/** Page frame: navbar, optional breadcrumb, heading with an optional action, then the page body. */
export default function LifecycleShell({ children, title, eyebrow, lead, action, trail }) {
  const { language } = useLanguage();
  const t = translations[language];
  return <div className="shell">
    <PublicHeader />
    <main className="shell__main">
      {trail && <Breadcrumb items={trail} />}
      <div className="page-head">
        <div>
          <p className="page-head__eyebrow">{eyebrow || t.workspaceEyebrow}</p>
          <h1>{title}</h1>
          {lead && <p className="page-head__lead">{lead}</p>}
        </div>
        {action}
      </div>
      {children}
    </main>
  </div>;
}
